const updateItems = [
  { date: '07-31', title: '《暗夜追踪者》高清完整版上线', tag: '新片上线', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-30', title: '久久视频专区新增20部经典武侠修复资源', tag: '资源更新', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-30', title: '91在线视频播放器升级，4K画质全面支持', tag: '系统升级', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-29', title: '《盛夏光年》豆瓣开分9.1，青春片年度黑马', tag: '热片速递', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-28', title: '91视频网站移动端适配优化完成，加载速度提升40%', tag: '体验优化', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-27', title: '悬疑片单专题上线，精选50部高智商烧脑佳作', tag: '专题上线', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-26', title: '《迷雾深渊》导演剪辑版独家上线', tag: '独家内容', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-25', title: '密桃视频与多家海外片方达成版权合作', tag: '平台动态', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-24', title: '动漫频道全新改版，追番体验全面升级', tag: '功能更新', tagColor: 'bg-accent-100 text-accent-700' },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 rounded-lg bg-secondary-100 flex items-center justify-center">
            <i className="ri-timer-line text-secondary-600 text-lg"></i>
          </div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">最新动态</h2>
        </div>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10 pl-11">实时追踪平台更新与资源上线，精彩不错过</p>

        <div className="relative pl-6 md:pl-8 border-l-2 border-background-200">
          {updateItems.map((item, i) => (
            <div key={i} className={`relative pb-6 md:pb-8 ${i === updateItems.length - 1 ? 'pb-0' : ''}`}>
              <div className="absolute -left-[calc(1.5rem+4px)] md:-left-[calc(2rem+4px)] top-0 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-1.5 sm:gap-3 mb-1.5">
                <span className="text-xs font-medium text-foreground-400 whitespace-nowrap">{item.date}</span>
                <span className={`inline-block px-2 py-0.5 rounded-md text-xs font-medium whitespace-nowrap w-fit ${item.tagColor}`}>
                  {item.tag}
                </span>
              </div>
              <p className="text-sm md:text-base text-foreground-800 font-medium">{item.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}